module.exports = __webpack_public_path__ + "media/images/icons/icn_047-f9590e577ccbe3b67ea64743471bbd01.svg";